<template>
  <div id="app">
    <SideBar v-bind:lineInfo="lineInfo">

    </SideBar>
    <Mapbox
      :nav-control="{
        show: false,
        position: 'top-right'
      }"
      :geolocate-control="{
        show: false,
        position: 'top-left'
      }"
      :scale-control="{
        show: false,
        position: 'top-left'
      }"
      :fullscreen-control="{
        show: false,
        position: 'top-left'
      }"

      access-token="pk.eyJ1IjoiZGVuZzIzIiwiYSI6ImNqNzhzZWFrMzI1aTMycXRjZmcyajVoOTYifQ.3RPzqTzCv20cZMQLYVlqIQ"
      :map-options="{
        style: 'mapbox://styles/deng23/cjratwtse1zj52spdvb6lm6oy'
      }"


      @map-mousemove="mouseMove"
    />
  </div>
</template>

<script>
import Mapbox from "mapbox-gl-vue";
import 'mapbox-gl/dist/mapbox-gl.css';
import SideBar from "./components/side-bar"
import { removeDuplicates } from "./Util"
//import HelloWorld from "./components/HelloWorld.vue"

export default {
  name: 'app',
  components: {
    Mapbox,
    SideBar
  },
  data: () => {
    return {
      lineInfo: []
    }
  },
  methods: {
    mouseMove(map, e) {

      const infoLayers = [
        'metro-lines',
        'light-rail',
        'commuter-lines',
        'tram-lines'
      ];

      const r = 8; // Radius

      let bbox = [[e.point.x - r, e.point.y - r], [e.point.x + r, e.point.y + r]];


      if (map.getZoom() > 10) {

        // Find features under pointer
        this.lineInfo = map.queryRenderedFeatures(bbox, {layers: infoLayers});

        // Remove duplicate refs
        this.lineInfo = removeDuplicates(this.lineInfo, 'properties.ref');

        // Sort values
        this.lineInfo = this.lineInfo.sort((a, b) =>
          // TODO: handle multi-digit numbers properly
          (a.properties.name > b.properties.name) ? 1 : -1
        );

        //for (let line in this.lineInfo) {

        //}
      }
    }
  }
}
</script>

<style>
  html,
  body {
    height: 100%;
    margin: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }

  #map {
    width: 80%;
    height: 100%;
    margin-left: 0%;
  }
</style>
